import { coerceDate } from '@/utils/dateKeys';

// Re-export Trip type from trips service for convenience
export type { Trip } from '@/services/trips';

// Helper function to format dates

const isLikelyInvalidDisplayDate = (date: Date): boolean =>
  !Number.isFinite(date.getTime()) || date.getFullYear() <= 1971;

export const formatTripDates = (startDate: Date | string | number, endDate: Date | string | number): string => {
  const start = coerceDate(startDate);
  const end = coerceDate(endDate);
  if (!start || !end || isLikelyInvalidDisplayDate(start) || isLikelyInvalidDisplayDate(end)) {
    return 'Dates TBD';
  }

  const now = new Date();
  const currentYear = now.getFullYear();
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  
  // Only show year if it's different from current year or if trip spans multiple years
  const showYear = startYear !== currentYear || endYear !== currentYear || startYear !== endYear;
  
  const startFormat: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
  const endFormat: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
  
  if (showYear && endYear !== currentYear) {
    endFormat.year = 'numeric';
  }
  
  const startLabel = start.toLocaleDateString('en-US', startFormat);
  const endLabel = end.toLocaleDateString('en-US', endFormat);
  const daysDiff = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;
  if (!Number.isFinite(daysDiff) || daysDiff <= 0) {
    return `${startLabel}-${endLabel}`;
  }
  return `${startLabel}-${endLabel} (${daysDiff} ${daysDiff === 1 ? 'day' : 'days'})`;
};

// Helper function to calculate days until trip
export const calculateDaysUntil = (startDate: Date): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const diffTime = start.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

